import openqasm from "refractor/openqasm";
export default openqasm;